/* eslint-disable import/no-anonymous-default-export */
import Confirmation from "./ConfirmationDialog";
import { createConfirmation } from "react-confirm";

const confirm = createConfirmation(Confirmation);

export default function (confirmation, options = {}) {
  return confirm({ confirmation, ...options });
}
